import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';

if ('serviceWorker' in navigator) {
    navigator.serviceWorker
        .register('/service-worker.js', {
            scope: '/',
            type: 'module'
        })
        .then(() => {
            console.info('Service Worker registered');
        })
        .catch(() => {
            console.error('Service Worker registration failed');
        });
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const width = window.innerWidth;
const height = window.innerHeight;

if (width > height) {
    const url = new URL(window.location.href);
    root.render(<iframe className='app' title='DID' src={url.toString()} />);
} else {
    root.render(
        <React.StrictMode>
            <App />
        </React.StrictMode>
    );
}
